import { ModelOptions } from './model-options';

export class MeasurementToolListOptions extends ModelOptions {
    public readonly maxEntries: number;
    public readonly isDeletable: boolean;
    public readonly isNoToolAllowed: boolean;
    public constructor({
        maxEntries = Infinity,
        isDeletable = true,
        isNoToolAllowed = true,
    }: { maxEntries?: number; isDeletable?: boolean; isNoToolAllowed?: boolean } = {}) {
        super();
        this.maxEntries = maxEntries;
        this.isDeletable = isDeletable;
        this.isNoToolAllowed = isNoToolAllowed;
    }
}

export class MeasurementToolListOptionsFromJson extends MeasurementToolListOptions {
    public constructor(data: JsonMeasurementToolListOptions) {
        super({
            maxEntries: data.maxEntries ? data.maxEntries : Infinity,
            isDeletable: data.isDeletable,
            isNoToolAllowed: data.isNoToolAllowed,
        });
    }
}

export interface JsonMeasurementToolListOptions {
    maxEntries: number;
    isDeletable: boolean;
    isNoToolAllowed: boolean;
}
